import Tremol from "./fp_ext";
import Const, { ScaleTypes } from "../../constants";

const ZfpLabServerVersionArray = [1, 7, 8];

export default class FpMixin extends Tremol.FP {
  constructor() {
    super();
    this.lastQRCode = "";
    this.loadingMessage = "";
    this.__errorMessage = null;
    this.__errorTO = 5000;
    this.__errorInterval = null;
    this.__errorShowStatus = false;
    this.isConnectedToServer = false;
    this.isConnectedToDevice = false;
    this.isSearchingForDevice = false;
    this.isSearchingForServer = false;
    this.mode = 0;
    this.callbacks = {};
    this.departments = [];
    this.articles = [];
    this.clients = [];
    this.maxSupportedDeps = 40;
    this.maxSupportedArts = 100000;
    this.maxSupportedClients = 0;
    this.isNew = false;
    this.serialNumber = null;
    this.model = null;
    this.operator1pass = null;
    this.externalDisplayPort = null;
    this.externalDisplayCodePage = Const.CodePages[0];
    this.scalePort = null;
    this.scaleType = Const.ScaleTypes.ACS15;
    this.ZFPLabServerVersion = "";
  }

  async sendFpSettings() {
    var isOnCom = localStorage.getItem(Const.DeviceIsWorkingOnSerialPort);
    switch (isOnCom) {
      case "true":
        var port = localStorage.getItem(Const.DeviceSerialPortName);
        var baud = localStorage.getItem(Const.DeviceBaudRate);
        await this.ServerSetDeviceSerialSettings(port, baud, true, false);
        break;

      case "false":
        var ip_address = localStorage.getItem(Const.DeviceIPAddress);
        var tcp_pass = localStorage.getItem(Const.DevicePassword);
        await this.ServerSetDeviceTcpSettings(ip_address, 8000, tcp_pass);
        break;
    }
  }

  async checkServerVersionGetError() {
    try {
      var err = null;
      if (
        localStorage.getItem(Const.DeviceSerialPortName).toLocaleLowerCase() != "sts" &&
        !Tremol.FP.IsOnAndroid() &&
        !navigator.userAgent.toLowerCase().indexOf("linux") > -1
      ) {
         var ver = await this.ServerGetDeviceSettings();
        this.ZFPLabServerVersion = ver.serverVersion;
        var arr = this.ZFPLabServerVersion.split(".");
        
        for (var i = 0; i < arr.length; i++) {
          if (ZfpLabServerVersionArray.length < i) break;
          if (ZfpLabServerVersionArray[i] == Number(arr[i])) {
            continue;
          } else if (ZfpLabServerVersionArray[i] < Number(arr[i])) {
            break;
          } else {
            err = "Моля обновете ZFPLabServer";
            break;
          }
        }
      }
    } catch (sx) {
       err = "Грешка " + sx.message;
      if (
        sx instanceof Tremol.ServerError &&
        sx.type === Tremol.ServerErrorType.ServerErr
      ) {
       err = null;
      }
    }
    return err;
  }

  async connect() {
    try {
      this.isSearchingForDevice = true;
      this.isConnectedToDevice = false;
      this.model = null;
      this.operator1pass = null;
      if (localStorage.getItem(Const.DeviceSerialPortName).toLocaleLowerCase() != "sts") {
        await this.sendFpSettings();
        try {
          await this.ApplyClientLibraryDefinitions();
        } catch {
          this.isConnectedToServer = false;
          throw new Error("Моля, обновете ZFPLabServer!");
        }
      }
      //await this.checkDateAndTime();
      var st = await this.ReadStatus();
      if (st.DateTime_not_set || st.DateTime_wrong) {
        this.addMode(Const.Modes.SetDateTime, () => {
          this.connect();
        });
      } else {
        var sn = (await this.ReadSerialAndFiscalNums()).SerialNumber;
        this.model = (await this.ReadVersion()).Model.replace(
          "TREMOL",
          "Tremol",
        );
        var filename =
          (this.model.endsWith("V2")
            ? this.model.substring(0, this.model.length - 3)
            : this.model) + ".png";

        this.Image = require("../img/" + filename);

        this.isNew = !this.model.endsWith("V2");
        this.operator1pass = (await this.ReadOperatorNamePassword(1)).Password;
        await this.RawWrite(new Uint8Array([0x1d, 0x49]));
        let res = (await this.RawRead(0, "\n"))
          .toUnicodeString()
          .trim()
          .split(";");
        this.maxSupportedArts = res[1];
        if (res[10]) {
          this.maxSupportedClients = parseInt(res[10].trim());
        } else {
          this.maxSupportedClients = 0; //???
        }

        if (localStorage.getItem(Const.SettingsMenuInLeft) == null) {
          this.addMode(Const.Modes.Settings);
          this.setInfoMessage(
            "Стартирате приложението за първи път.\nМоля, конфигурирайте системата спрямо нуждите си.",
          );
        } else {
          this.addMode(Const.Modes.Sales);
        }
        if (sn != this.serialNumber) {
          this.departments = [];
          this.articles = [];
          this.clients = [];
        }
        this.serialNumber = sn;
        this.isConnectedToDevice = true;
        var isOnCom = localStorage.getItem(Const.DeviceIsWorkingOnSerialPort);
        if (
          isOnCom &&
          localStorage.getItem(Const.ScaleType) &&
          localStorage.getItem(Const.ScalePortName) ==
            localStorage.getItem(Const.DeviceSerialPortName)
        ) {
          this.fp.scaleType = "";
          this.uiSettings.scaleType = "";
          this.fp.scalePort = "";
          this.uiSettings.scalePort = "";
          this.fp.setErrorMessage(
            "На този сериен порт е била конфигурирана везна. Везната е премахната от настройките.",
          );
        }
        if (
          isOnCom &&
          localStorage.getItem(Const.ExternalDisplayPortName) ==
            localStorage.getItem(Const.DeviceSerialPortName)
        ) {
          this.fp.externalDisplayPort = "";
          this.uiSettings.externalDisplayPort = "";
          this.fp.externalDisplayCodePage = "";
          this.uiSettings.externalDisplayCodePage = "";
          this.fp.setErrorMessage(
            "На този сериен порт е бил конфигуриран външен дисплей. Дисплея е премахнат от настройките.",
          );
        }
      }
    } finally {
      this.isSearchingForDevice = false;
    }
  }

  async GetScaleQuantity() {
    try {
      var btz = [];
      var b = 0x00;
      switch (this.scaleType) {
        case ScaleTypes.NONE: {
          throw Error("Не е настроена везна!");
        }
        case ScaleTypes.SCALE_ON_FD: {
          return Number(await this.DirectCommand("ZQ"));
        }
        case ScaleTypes.ACS15: {
          await this.ServerSetDeviceSerialSettings(
            this.scalePort,
            9600,
            true,
            true,
            3000,
          );

          for (var i = 0; i <= 15; i++) {
            b = (await this.RawRead(1, null))[0];
            if (b == 0xff) break;
          }
          if (b != 0xff) {
            throw new Error("Липсва стартов байт в комуникацията (0xFF)!");
          }
          btz = await this.RawRead(13, null);
          var decimals = btz[0] & 7;
          return (
            (parseInt(btz[1].toString(16), 10) +
              parseInt(btz[2].toString(16), 10) * 100 +
              parseInt(btz[3].toString(16), 10) * 10000) /
            parseInt("1".padEnd(decimals, "0"))
          );
        }
        case ScaleTypes.BIMCO: {
          await this.ServerSetDeviceSerialSettings(
            this.scalePort,
            9600,
            true,
            true,
            3000,
          );
          await this.RawWrite(new Uint8Array([0xaa]));

          b = (await this.RawRead(1, null))[0];
          if (b == 0xbb) {
            throw new Error("Няма нищо на везната!");
          } else if (b == 0x00) {
            btz = await this.RawRead(3, null);
            if (btz[0] + btz[1] == btz[2]) {
              return (
                (parseInt(btz[0].toString(16), 10) * 100 +
                  parseInt(btz[1].toString(16), 10)) /
                1000
              );
            } else {
              throw new Error("Грешна контролна сума от везната!");
            }
          } else {
            throw new Error("Неизвествен отговор от везната!");
          }
        }
        case ScaleTypes.DATECS: {
          await this.ServerSetDeviceSerialSettings(
            this.scalePort,
            9600,
            true,
            true,
            3000,
          );
          await this.RawWrite(
            new Uint8Array([0x00, 0x00, 0x02, 0x00, 0x00, 0x00, 0x00, 0x00]),
          );

          btz = await this.RawRead(17, null);
          var res = 0;
          for (var u = btz.length - 1; u >= 0; u--) {
            res += btz[u] * Math.pow(10, u);
          }
          if (res == 0) {
            throw new Error("Няма нищо на везната!");
          }
          return res / 1000;
        }
      }
    } catch (ex) {
      throw Error("Грешка при измерване.\n\n" + ex.message);
    } finally {
      try {
        await this.sendFpSettings();
      } catch {
        /**ignored */
      }
    }
  }
  hasScale() {
    return this.scaleType == Const.ScaleTypes.SCALE_ON_FD || !!this.scalePort;
  }
  hasExternalDisplay() {
    return !!this.externalDisplayPort;
  }
  async ExternalDisplayShowItem(text1, sum1, text2, sum2) {
    if (this.hasExternalDisplay()) {
      try {
        await this.ServerSetDeviceSerialSettings(
          this.externalDisplayPort,
          9600,
          true,
          true,
        );
        var line1 = "";
        var line2 = "";
        if (sum1 != null) {
          line1 = text1 + sum1.toFixed(2).padStart(20 - text1.length, " ");
        } else {
          line1 = text1.padEnd(20, " ").substring(0, 20);
        }
        if (sum2 != null) {
          line2 = text2 + sum2.toFixed(2).padStart(20 - text2.length, " ");
        } else {
          line2 = text2.padEnd(20, " ").substring(0, 20);
        }

        var buff = null;
        if (this.externalDisplayCodePage == Const.CodePages[0]) {
          buff = (line1 + line2).utfToWin1251().stringToUint8ArrayBuffer();
        } else if (this.externalDisplayCodePage == Const.CodePages[1]) {
          buff = (line1 + line2).utfToWin866().stringToUint8ArrayBuffer();
        }
        await this.RawWrite(buff.toBase64string());
      } catch (ex) {
        this.setErrorMessage(
          "Грешка при изпращане към външен дисплей!\nАко дисплея не работи, моля премахнете го от настройките!\n" +
            ex.message,
        );
      } finally {
        await this.sendFpSettings();
      }
    }
  }

  async ExtDisplayClear() {
    if (this.hasExternalDisplay()) {
      await this.RawWrite(new Uint8Array([0x1b, 0x40]));
    }
  }

  isInMode(mode) {
    return (this.mode & mode) > 0; //(this.isConnectedToDevice && (this.mode & mode) > 0);
  }

  /**
   * @param { Const.Modes } mode
   * @param { function() } callback
   * @memberof FpMixin
   */
  addMode(mode, callback) {
    if (callback) this.callbacks[mode] = callback;
    this.mode |= mode;
  }

  exitMode(mode) {
    if (this.callbacks[mode]) {
      this.callbacks[mode]();
      this.callbacks[mode] = null;
    }
    this.mode = this.mode & ~mode;
  }

  async executeWithLoader(fn, msg) {
    try {
      this.loadingMessage = "";
      this.loadingMessage = msg;
      await fn();
    } finally {
      this.loadingMessage = "";
    }
  }
  getStatusMessage(s) {
    try {
      if (
        s.FM_error ||
        s.FM_Read_only ||
        s.No_FM_module ||
        s.Hardware_clock_error ||
        s.Wrong_SD_card ||
        s.Wrong_SIM_card ||
        s.No_GPRS_Modem ||
        s.No_SIM_card
      ) {
        return "Хардуерна грешка!  Моля, свърежете се с обслужващия сервиз!";
      } else if (s.FM_full || s.SD_card_full) {
        return "Фискалното устройство е с пълна памет! Моля, свърежете се с обслужващия сервиз!";
      } else if (s.Printer_not_ready_overheat) {
        return "Прегрят принтер! Моля, свържете се с обслужващия сервиз!";
      } else if (
        s.Blocking_3_days_without_mobile_operator ||
        s.Unsent_data_for_24_hours
      ) {
        return "ФУ е блокирало поради липса на връзката с НАП! Моля, свърежете се с обслужващия сервиз!";
      } else if (s.No_task_from_NRA) {
        return "ФУ няма задача от НАП! Моля, свърежете се с обслужващия сервиз!";
      } else if (s.RAM_reset) {
        return "ФУ е претърпяло ресет! Моля, свърежете се с обслужващия сервиз!";
      } else if (s.DateTime_not_set || s.DateTime_wrong) {
        return "Моля, сверете часовника на фискалното устройство!";
      } else if (s.Reports_registers_Overflow) {
        return "Препълване на регистрите за отчети на ФУ!";
      } else if (s.Printer_not_ready_no_paper) {
        return "Липсва хартия!";
      } else if (
        s.Opened_Non_fiscal_Receipt ||
        s.Opened_Fiscal_Receipt ||
        s.Opened_Invoice_Fiscal_Receipt
      ) {
        return "ФУ е в състояние на отворен бон!";
      }
    } catch (ex) {
      return null;
    }
  }

  setErrorMessage(errText, showStatusBtn, dontHide) {
    this.setMessage(errText, showStatusBtn, dontHide, true);
  }
  setInfoMessage(errText) {
    this.setMessage(errText, false, true, false);
  }

  setMessage(errText, showStatusBtn, dontHide, isError) {
    this.__errorMessage = null;
    this.__errorMessage = errText;
    this.__errorShowStatus = showStatusBtn;
    this.loadingMessage = "";
    if (errText) {
      if (isError) {
        this.addMode(Const.Modes.Error);
      } else {
        this.addMode(Const.Modes.Info);
      }
      if (!dontHide) {
        clearTimeout(this.__errorInterval);
        this.__errorInterval = setTimeout(() => {
          this.__errorMessage = null;
          this.exitMode(Const.Modes.Error);
          this.exitMode(Const.Modes.Info);
        }, this.__errorTO);
      }
    } else {
      this.exitMode(Const.Modes.Error);
      this.exitMode(Const.Modes.Info);
    }
  }

  getErrorMessage() {
    return this.__errorMessage;
  }

  async checkDateAndTime() {
    var dt = await this.ReadDateTime();
    var dtNum = dt.getTime();
    var now = new Date().getTime();
    var hours2 = 2 * 60 * 60 * 1000;
    if (now + hours2 < dtNum || now - hours2 > dtNum) {
      this.addMode(Const.Modes.SetDateTime);
      this.setErrorMessage(
        "Разлика в часовника на компютъра и часовника на ФУ с повече от 2 часа!",
      );
      return false;
    }
    return true;
  }

  handleException(sx) {
    if (sx instanceof Tremol.ServerError) {
      if (sx.isFpException) {
        /** 
          Possible Communication reasons:
          sx.fpLibError =
              0x102 Timeout while reading data from the fiscal device
              0x109 The fiscal device is missing
              0x10A The fiscal device is busy
              0x10F The connection with the device is not available anymore
              0x110 Out of paper
              0x111 Fiscal device has already opened connection from another client and refuses new one
              0x112 Wrong ZFP network password
              0x113 Fiscal device is waiting for network password
          */
        if (sx.fpLibError === 0x102) {
          this.setErrorMessage("Таймаут при четене от ФУ");
        } else if (sx.fpLibError === 0x109) {
          this.setErrorMessage("ФУ липсва");
        } else if (sx.fpLibError === 0x10a) {
          this.setErrorMessage(
            "ФУ е заето и не може да изпълни командата в момента",
          );
        } else if (sx.fpLibError === 0x10f) {
          this.setErrorMessage("Разпадната връзка с ФУ");
        } else if (sx.fpLibError === 0x110) {
          this.setErrorMessage("Липсва хартия");
        } else if (sx.fpLibError === 0x111) {
          this.setErrorMessage(
            "Неуспешно свързване с ФУ, в момента друг клиент комуникира с това ФУ",
          );
        } else if (sx.fpLibError === 0x112) {
          this.setErrorMessage("Грешна ZFP мрежова парола");
        } else if (sx.fpLibError === 0x113) {
          this.setErrorMessage("ФУ очаква ZFP мрежова парола");
        } else if (sx.ste1 === 0x30 && sx.ste2 === 0x32) {
          /**
          Possible Logical reasons:  
          sx.STE1 =                                              sx.STE2 =
              0x30 OK                                                   0x30 OK                                 
              0x31 Out of paper, printer failure                        0x31 Invalid command
              0x32 Registers overflow                                   0x32 Illegal command
              0x33 Clock failure or incorrect date&time                 0x33 Z daily report is not zero
              0x34 Opened fiscal receipt                                0x34 Syntax error
              0x35 Payment residue account                              0x35 Input registers overflow
              0x36 Opened non-fiscal receipt                            0x36 Zero input registers
              0x37 Registered payment but receipt is not closed         0x37 Unavailable transaction for correction
              0x38 Fiscal memory failure                                0x38 Insufficient amount on hand
              0x39 Incorrect password                                   0x3A No access
              0x3a Missing external display
              0x3b 24hours block – missing Z report
              0x3c Overheated printer thermal head.
              0x3d Interrupt power supply in fiscal receipt (one time until status is read)
              0x3e Overflow EJ
              0x3f Insufficient conditions
          **/
          this.setErrorMessage(
            "Командата е непозволена в текущото състояние на ФУ.",
            true,
          );
        } else if (sx.ste1 === 0x30 && sx.ste2 === 0x33) {
          this.setErrorMessage(
            "Ненулев отчет. Необходимо е да се направи Z отчет.",
          );
        } else if (sx.ste1 === 0x30 && sx.ste2 === 0x35) {
          this.setErrorMessage(
            "Невалидни входни данни. Прекалено голяма стойност!",
          );
        } else if (sx.ste1 === 0x30 && sx.ste2 === 0x38) {
          this.setErrorMessage("Недостатъчна касова наличност.");
        } else if (sx.ste1 === 0x32 && sx.ste2 === 0x35) {
          this.setErrorMessage("Достигнат е лимита на артикули в текущия бон!");
        } else if (sx.ste1 === 0x34 && sx.ste2 === 0x32) {
          this.setErrorMessage(
            "Отворен фискален бон. Командата е непозволена в текущото състояние на ФУ.",
            true,
          );
        } else if (sx.ste1 === 0x34 && sx.ste2 === 0x36) {
          this.setErrorMessage(
            "В операцията има цена или количество 0. Моля, коригирайте.",
          );
        } else if (sx.ste1 === 0x34 && sx.ste2 === 0x38) {
          this.setErrorMessage("Недостатъчна наличност.");
        } else if (sx.ste1 === 0x35 && sx.ste2 === 0x32) {
          this.setErrorMessage("Недостатъчно плащане по текущия бон!");
        } else if (sx.ste1 === 0x35 && sx.ste2 === 0x35) {
          this.setErrorMessage("Прекалено голяма сума за плащане!");
        } else if (sx.ste1 === 0x37 && sx.ste2 === 0x32) {
          this.setErrorMessage(
            "Има текущ отворен бон със започнато плащане. Командата е непозволена.",
            true,
          );
        } else if (sx.ste1 === 0x39 && sx.ste2 === 0x32) {
          this.setErrorMessage("Грешна парола. Командата е непозволена.");
        } else if (sx.ste1 === 0x3b && sx.ste2 === 0x32) {
          this.setErrorMessage(
            "Ненулев отчет. Необходимо е да се направи Z отчет.",
          );
        } else if (sx.ste1 === 0x3f && sx.ste2 === 0x32) {
          this.setErrorMessage("Недостатъчни условия, непозволена команда!");
        } else {
          this.setErrorMessage(
            sx.message + "\nSTE1=" + sx.ste1 + ", STE2=" + sx.ste2,
          );
        }
      } else if (sx.type === Tremol.ServerErrorType.ServerDefsMismatch) {
        this.setErrorMessage(
          "Текущата версия на библиотеката и сървърните дефиниции се различават.",
        );
      } else if (
        sx.type ===
        Tremol.ServerErrorType.ServMismatchBetweenDefinitionAndFPResult
      ) {
        this.setErrorMessage(
          "Текущата версия на библиотеката и фърмуера на ФУ са несъвместими",
        );
      } else if (sx.type === Tremol.ServerErrorType.ServerAddressNotSet) {
        this.setErrorMessage("Не е зададен адрес на сървъра!");
      } else if (sx.type === Tremol.ServerErrorType.ServerConnectionError) {
        this.setErrorMessage(
          "Не може да се осъществи връзка със ZfpLab сървъра",
        );
      } else if (sx.type === Tremol.ServerErrorType.ServSockConnectionFailed) {
        this.setErrorMessage("Сървъра не може да се свърже с ФУ");
      } else if (sx.type === Tremol.ServerErrorType.ServTCPAuth) {
        this.setErrorMessage("Грешна TCP парола на устройството");
      } else if (
        sx.type ===
        Tremol.ServerErrorType.ServWaitOtherClientCmdProcessingTimeOut
      ) {
        this.setErrorMessage(
          "Обработката на другите клиенти на сървъра отнема много време",
        );
      } else {
        this.setErrorMessage(sx.message);
      }
    } else {
      this.setErrorMessage(sx.message);
    }
    // console.log("handleException");
    // console.log(sx);
    // console.log(fpc.getErrorMessage());
  }
}
